module.exports = __webpack_public_path__ + "static/media/ImporterFeature8.1414b591.svg";